
import { SliderValueType } from "./pricingTier";
interface BoundsType {lowerBound:number, upperBound:number};
//quantity(key) & slider step changing interval(value)

const tierMap = {
    0: 10,
    150: 20,
    350: 50,
    1500: 200,
    2500: 500,
  };

  const findBounds = (val:number, mapToFindFrom = tierMap) => {
    let lowerBound:number = Number.NEGATIVE_INFINITY;
    let upperBound:number = Number.POSITIVE_INFINITY;
    const keys:string[] = Object.keys(mapToFindFrom);
    for (let key of keys) {
      const keyNumber = Number(key);
      if (keyNumber <= val && keyNumber > lowerBound) {
        lowerBound = keyNumber;
      } else if (keyNumber < upperBound) {
        upperBound = keyNumber;
      }
    }
    return { lowerBound: Number(lowerBound), upperBound: Number(upperBound) };
  };
  const nextMultipleOfTen = (number):number => {
    return Math.ceil(number / 10) * 10;
  };
  
  const checkValidity = (qty:number, lb:number, curInc:number) => {
    let rem:number = (qty - lb) % curInc;
    return rem === 0;
  };
  //below 2 functions are for decreasing the complexity hence for performance
  const sliderStepToOriginalQuantity = (sliderStepsToQuantityIncrementMap) => {
    let sliderStepsToQuantityMap = {}
    const keys:string[] = Object.keys(sliderStepsToQuantityIncrementMap);
    let prevKey:number = 0;
    let prevVal:number = 0;
    for(const currentKey of keys){
        let currentVal = ((Number(currentKey)-prevKey)*Number(sliderStepsToQuantityIncrementMap[currentKey])) + prevVal;
        sliderStepsToQuantityMap[currentKey] = currentVal;
        prevKey = Number(currentKey);
        prevVal = currentVal;
    }
    return sliderStepsToQuantityMap;
}

const quantityToSliderSteps = (sliderStepsToQuantityIncrementMap,moq) => {
   let quantityToSliderStepMap={}
    quantityToSliderStepMap[moq] = 0;
    const keys:string[] = Object.keys(sliderStepsToQuantityIncrementMap);
    let prevKey:number = moq;
    let prevVal:number = 0;
    for(const currentKey of keys){
        let newKey = prevKey + (Number(currentKey) - prevVal) * Number(sliderStepsToQuantityIncrementMap[currentKey]);
        let newVal = Number(currentKey);
        quantityToSliderStepMap[newKey] = newVal;
        prevKey = newKey;
        prevVal = newVal;
    }
    return quantityToSliderStepMap;

}
const getSliderValForQty = (qty, quantityToStepsObj) => {
    let bounds:BoundsType = findBounds(qty);
    let curInc:number = tierMap[bounds?.lowerBound];
    let bound2:BoundsType = findBounds(qty, quantityToStepsObj);
    return (quantityToStepsObj[bound2?.lowerBound] + Math.round((qty - bound2?.lowerBound) / curInc));
};

const getActualQty = (val, min, sliderStepToOriginalIncrementMap,stepsToQuantityObj) => {
    let actualVal:number = min;
    let bounds:BoundsType = findBounds(val, sliderStepToOriginalIncrementMap);
    let temp = 0;
    if (val !== bounds?.lowerBound) {
      let currInc:number = sliderStepToOriginalIncrementMap[bounds?.upperBound];
      temp = (val - (bounds?.lowerBound > 0 ? bounds?.lowerBound : 0)) * currInc;
    }
    if (bounds?.lowerBound > 0){
      actualVal = actualVal + stepsToQuantityObj[bounds?.lowerBound];
    }
    actualVal = actualVal + temp;
    return actualVal;
  };

const provideSliderValues = (moq:number, hoq:number,selectedQty:number):any => {
    let totalSteps:number = 0, sliderStepToOriginalIncrementMap:any = {}, prev:number = 0,current:number = moq, sliderValues:SliderValueType={
      min: 0,
      max: 0,
      value: 0,
      sliderStepToOriginalIncrementMap: undefined,
      stepsToQuantityObj: undefined,
      quantityToStepsObj: undefined
    };
         // first check if moq is multiple of 10 or not
         if(current%10){
             let temp:number = nextMultipleOfTen(current);
             if(temp <= hoq){
                 current = temp;
                 let lowerBound:number = findBounds(current)?.lowerBound;
                 let currInc:number = tierMap[lowerBound];
                 if (checkValidity(current, lowerBound, currInc)) {
                     sliderStepToOriginalIncrementMap[1] = current - moq;
                 } else {
                     let newNumber:number = current + currInc;
                     let rem:number = (newNumber - lowerBound) % currInc;
                     newNumber = current + rem;
                     sliderStepToOriginalIncrementMap[1] = newNumber - moq;
                     current = newNumber;
                 }
                 prev = 1;
                 totalSteps = 1;
             } 
         }  else{
             let lowerBound:number = findBounds(current)?.lowerBound;
             let currInc:number = tierMap[lowerBound];
             if(!checkValidity(current,lowerBound,currInc)){
                 let newNumber = current + currInc;
                 let rem = (newNumber - lowerBound) % currInc;
                 newNumber = current + rem;
                 sliderStepToOriginalIncrementMap[1] = newNumber - moq; 
                 current = newNumber;
                 prev = 1;
                 totalSteps = 1;
             }
         }
         let bounds:BoundsType = findBounds(current);
         let currInc:number = tierMap[bounds?.lowerBound];
         
         while(bounds?.upperBound <= hoq){
             let key = prev + ((bounds?.upperBound-current)/currInc);
             sliderStepToOriginalIncrementMap[key] = currInc;
             totalSteps = key;
             prev = key;
             current = bounds?.upperBound;
             bounds = findBounds(current);
             currInc = tierMap[bounds?.lowerBound];
         }
 
         let difference:number = hoq-current;
         if (difference){
             let remainder:number = difference%currInc;
             let quotient:number = Math.floor(difference/currInc);
             if(quotient){
                 let key = prev + quotient;
                 totalSteps = key;
                 sliderStepToOriginalIncrementMap[key] = currInc;
                 prev = key;
             }
             if(remainder){
                 let key = prev + 1;
                 totalSteps = key;
                 sliderStepToOriginalIncrementMap[key] = remainder;
             }
         }
         const quantityToSliderStepsValue = quantityToSliderSteps(sliderStepToOriginalIncrementMap,moq)
         if(totalSteps > 0){
            sliderValues["min"] = 0;
            sliderValues["max"] = totalSteps;
            sliderValues["value"] = selectedQty?getSliderValForQty(selectedQty, quantityToSliderStepsValue):0;
            sliderValues["sliderStepToOriginalIncrementMap"]= sliderStepToOriginalIncrementMap;
            sliderValues["stepsToQuantityObj"] = sliderStepToOriginalQuantity(sliderStepToOriginalIncrementMap);
            sliderValues["quantityToStepsObj"] = quantityToSliderStepsValue;
            return sliderValues;
        }
        return undefined;
  }
  export {tierMap, findBounds, provideSliderValues, getSliderValForQty, getActualQty}